import React from "react";
import Button from "../../../components/Button";

export default function Template2({ data }) {
  if (!data) return <p>No data found for Blog</p>;
  return (
    <>
      <div>
        {data.MainHeading && <h1>{data.MainHeading}</h1>}
        {data.IntroductionP && <p>{data.IntroductionP}</p>}
        {data.Subheading1 && (
          <>
            <h3>{data.Subheading1}</h3>
          </>
        )}
        {data.Subp1 && (
          <>
            <p>
              {data.Subp1.map((p) => (
                <>
                  <p>{p.p1}</p>
                  <p>{p.p2}</p>
                </>
              ))}
            </p>
          </>
        )}
        {data.Subheading2 && (
          <>
            <h3>{data.Subheading2}</h3>
          </>
        )}
        {data.Subp2 && (
          <>
            <p>{data.Subp2}</p>
          </>
        )}
        {data.Sub2ol && (
          <ol>
            {data.Sub2ol.map((item, index) => (
              <li key={index}>
                {item.li.map((l, i) => (
                  <>
                    <strong key={i}>{l.strong}</strong>
                    <p key={i}>{l.p}</p>
                  </>
                ))}
              </li>
            ))}
          </ol>
        )}
        {data.Subheading3 && (
          <>
            <h3>{data.Subheading3}</h3>
            {data.Subp3 && (
              <>
                <p>
                  {data.Subp3.map((p) => (
                    <>
                      <p>{p.p}</p>
                    </>
                  ))}
                </p>
              </>
            )}
          </>
        )}
        {data.Sub3ol && (
          <ol>
            {data.Sub3ol.map((item, index) => (
              <li key={index}>
                {item.li.map((l, i) => (
                  <>
                    <strong key={i}>{l.strong}</strong>
                    <p key={i}>{l.p}</p>
                  </>
                ))}
              </li>
            ))}
          </ol>
        )}
        {data.Subheading4 && (
          <>
            <h3>{data.Subheading4}</h3>
          </>
        )}
        {data.Subp4 && (
          <>
            <p>
              {data.Subp4.map((p) => (
                <>
                  <p>{p.p}</p>
                </>
              ))}
            </p>
          </>
        )}
        {data.Subheading5 && (
          <>
            <h3>{data.Subheading5}</h3>
            <p>{data.Subp5}</p>
            <div className=" btn-group">
              {data.WhatsAppbutton && (
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    window.open("https://wa.me/+27630680075", "_blank")
                  }
                >
                  WhatsApp
                </button>
              )}
            </div>
            <div className=" btn-group m-2">
              {data.Emailbutton && (
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    window.open("mailto:apply@webridge.co.za", "_blank")
                  }
                >
                  Email
                </button>
              )}
            </div>
          </>
        )}
        {data.Subheading6 && (
          <>
            <h3>{data.Subheading6}</h3>
            <p>
              {data.Subp6.map((p) => (
                <>
                  <p>{p.p1}</p>
                  <p>{p.p2}</p>
                </>
              ))}
            </p>
          </>
        )}
      </div>
    </>
  );
}
